/* eslint-disable import/first */
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Login from './login';
import News from './news';
import MenuItems from './MenuItems';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXTwitter, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import assetUrl from '../../services/assetUrl';
import siteDefault from '../../data/site/site.json';
import { getSiteSettings } from '../../services/data.service';
const normalLogo = assetUrl('/Torii/logo/ncetlogo_darktext.png');
// import stickyLogo from '../../assets/images/logos/au.png';
import './header.scss';

const WHATSAPP_LINK = "https://wa.me/919900056854?text=Hi,%20I%20am%20looking%20for%20admissions,%20can%20I%20get%20more%20info?";

// Accreditation badges that cross-fade beside the always-present NCET logo.
const ACCRED_LOGOS = [
	assetUrl('/images/accreditations/accreditations_8.png'),
	assetUrl('/images/accreditations/accreditations_9.png'),
];

// The NCET brand logo stays fixed; the accreditation badges cross-fade in a
// slot next to it. A hidden "sizer" holds that slot's width steady so nothing
// shifts as the badges — which have different aspect ratios — fade through.
const RotatingLogo = ({ logo, badges }) => {
	const [active, setActive] = useState(0);
	const mainLogo = logo || normalLogo;
	// Ensure at least 2 badges for smooth cross-fading, falling back to verified S3 marks
	const rawList = (badges && badges.length) ? badges : ACCRED_LOGOS;
	const list = rawList.length === 1 ? [rawList[0], ACCRED_LOGOS[1]] : rawList;

	useEffect(() => {
		if (list.length <= 1) return;
		const id = setInterval(() => setActive((p) => (p + 1) % list.length), 2800);
		return () => clearInterval(id);
	}, [list.length]);

	return (
		<span className="logo-pair">
			<img
				className="unified-logo"
				src={assetUrl(mainLogo)}
				alt="Nagarjuna College of Engineering & Technology"
				onError={(e) => {
					e.currentTarget.onerror = null;
					e.currentTarget.src = normalLogo;
				}}
			/>
			<span className="unified-logo logo-rotator logo-rotator--badge" aria-hidden="true">
				<img
					className="logo-rotator__sizer"
					src={assetUrl(list[0])}
					alt=""
					onError={(e) => {
						e.currentTarget.onerror = null;
						e.currentTarget.src = ACCRED_LOGOS[0];
					}}
				/>
				{list.map((src, i) => (
					<img
						key={src + i}
						src={assetUrl(src)}
						alt="NCET accreditation"
						className={`logo-rotator__img ${i === active ? "is-active" : ""}`}
						onError={(e) => {
							e.currentTarget.onerror = null;
							e.currentTarget.src = ACCRED_LOGOS[i % ACCRED_LOGOS.length];
						}}
					/>
				))}
			</span>
		</span>
	);
};

const Header = (props) => {
	const { topbarEnable, menuCategoryEnable, headerClass, parentMenu, headerNormalLogo, headerStickyLogo } = props;

	const [menuOpen, setMenuOpen] = useState(false)
	const [isVisible, setIsVisible] = useState(false);
	const location = useLocation();

	// Admin-editable header bits (logo + accreditation badges); bundled fallback.
	const [headerSettings, setHeaderSettings] = useState(siteDefault.header);
	useEffect(() => {
		let active = true;
		(async () => {
			try {
				const res = await getSiteSettings();
				const d = res?.data?.data; // SERVICE + wrapped doc → res.data.data
				if (active && d && d.header) setHeaderSettings(d.header);
			} catch (e) { /* keep bundled fallback */ }
		})();
		return () => { active = false; };
	}, []);

	useEffect(() => {
		// Sticky is displayed after scrolling for 100 pixels
		const toggleVisibility = () => {
			if (window.pageYOffset > 100) {
				setIsVisible(true);
			} else {
				setIsVisible(false);
			}
		};

		window.addEventListener("scroll", toggleVisibility);

		return () => window.removeEventListener("scroll", toggleVisibility);
	}, []);

	// Close the mobile drawer whenever the route changes.
	useEffect(() => {
		setMenuOpen(false);
	}, [location.pathname]);

	// Lock body scroll while the mobile drawer is open.
	useEffect(() => {
		document.body.style.overflow = menuOpen ? "hidden" : "";
		return () => {
			document.body.style.overflow = "";
		};
	}, [menuOpen]);

	return (
		<>
			<header id="react-header" className={headerClass ? headerClass : 'react-header react-header-three'}>
				<div className={isVisible ? 'header-area react-sticky' : 'header-area'}>
					<div className="topbar-area style1 unified-topbar" style={{ padding: '0', background: '#ffffff', width: '100%' }}>
						<div className="container">
							<div className="react-main-menu">
								<nav className={`custom-unified-header custom-unified-header--compact ${menuOpen ? "drawer-open" : ""}`}>
									<div className="menu-toggle logo-section">
										<div className="logo">
											<Link to="/" className="logo-text">
												<RotatingLogo logo={headerSettings.logo} badges={headerSettings.accreditationLogos} />
											</Link>
										</div>
										<button type="button" id="menu-btn" className={menuOpen ? "mobile-menu-btn open" : "mobile-menu-btn"} aria-label="Open menu" aria-expanded={menuOpen} onClick={() => { setMenuOpen(!menuOpen) }}>
											<span className="icon-bar"></span>
											<span className="icon-bar"></span>
											<span className="icon-bar"></span>
										</button>
									</div>

									<div className={`menu-section ${menuOpen ? "react-inner-menus menu-open" : "react-inner-menus"}`}>
										<div className="drawer-head">
											<Link to="/" className="drawer-logo-link"><RotatingLogo logo={headerSettings.logo} badges={headerSettings.accreditationLogos} /></Link>
											<button type="button" className="drawer-close" aria-label="Close menu" onClick={() => setMenuOpen(false)}>&times;</button>
										</div>
										<ul id="backmenu" className="react-menus react-sub-shadow">
											<MenuItems parentMenu={parentMenu} />
										</ul>
										<a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="drawer-cta">
											<FontAwesomeIcon icon={faWhatsapp} /> Connect Now
										</a>
									</div>

									<div className="header-cta-btn">
										<a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="wa-help-btn" aria-label="Connect now on WhatsApp">
											<FontAwesomeIcon icon={faWhatsapp} className="wa-icon" /> Connect Now
										</a>
									</div>

									<div
										className={`mobile-nav-overlay ${menuOpen ? "is-open" : ""}`}
										onClick={() => setMenuOpen(false)}
										aria-hidden="true"
									></div>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</header>
		</>
	);
}

export default Header;
